<script>
import ProjectStatsDashboard from "@supplier/ProjectStatsDashboard.vue";

export default {
  name: "origination-metrics",
  components: {ProjectStatsDashboard}
}
</script>

<template>
  <vx-card no-shadow>
    <project-stats-dashboard></project-stats-dashboard>
  </vx-card>
</template>

<style scoped>

</style>